// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
<DocumentFragment>
  <div>
    <button
      class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-fullWidth"
      tabindex="0"
      type="button"
    >
      <span
        class="MuiButton-label"
      >
        Continue
      </span>
      <span
        class="MuiTouchRipple-root"
      />
    </button>
  </div>
</DocumentFragment>
`;
